module.exports = __webpack_public_path__ + "videos/main-banner-mobile.7929db3.mp4";